import mitt from 'mitt'

/**
 * 全局信号发送接收器
 */
export const emitter = mitt();

/**
 * 信号类型
 */
export const EMITTER_TYPE = {
    WORKFLOW_UPDATE: 'WORKFLOW_UPDATE',
    NOTICE_TODO_COMPLETE: 'NOTICE_TODO_COMPLETE',

    TODO_COUNT_UPDATE: 'TODO_COUNT_UPDATE',

    /**
     * wbs-创建工作单元
     */
    WBS_CREATE: 'WBS_CREATE',

    /**
     * wbs-创建工作单元完毕
     */
    WBS_CREATE_FINISH: 'WBS_CREATE_FINISH',

    /**
    * wbs-文件树的文件夹重名信号
    */
    WBS_DELETE_TREE: 'WBS_DELETE_TREE',

    /**
     * wbs-文件面板的文件夹重名信号
     */
    WBS_DELETE_MAIN: 'WBS_DELETE_MAIN',

    /**
    * wbs-文件树的文件夹重名信号
    */
    WBS_RENAME_TREE: 'WBS_RENAME_TREE',

    /**
     * wbs-文件面板的文件夹重名信号
     */
    WBS_RENAME_MAIN: 'WBS_RENAME_MAIN',

    /**
     * File-创建文件夹
     */
    FILE_CREATE: 'FILE_CREATE',

    /**
     * File-创建文件夹完毕
     */
    FILE_CREATE_FINISH: 'FILE_CREATE_FINISH',

    /**
     * File-删除文件/文件夹
     */
    FILE_DELETE: 'FILE_DELETE',

    /**
     * File-删除文件/文件夹完毕
     */
    FILE_DELETE_FINISH: 'FILE_DELETE_FINISH',

    /**
    * File-文件树的文件夹重名信号
    */
    FILE_RENAME_TREE: 'FILE_RENAME_TREE',

    /**
     * File-文件面板的文件夹重名信号
     */
    FILE_RENAME_MAIN: 'FILE_RENAME_MAIN',

    /**
     * 发通知
     */
    SEND_NOTICE: 'SEND_NOTICE',
    /**
     * 发任务
     */
    SEND_TASK: 'SEND_TASK',

    // 通用信号
    COMMON_DELETE: 'COMMON_DELETE',
    COMMON_CREATE: 'COMMON_CREATE',
    COMMON_UPDATE: 'COMMON_UPDATE',
    COMMON_SELECT: 'COMMON_SELECT',
    COMMON_UPLOAD: "COMMON_UPLOAD",
    COMMON_DOWNLOAD: "COMMON_DOWNLOAD",

    // 会议状态变更
    MEETING_STATUS_UPDATE: 'MEETING_STATUS_UPDATE',

    // 解析简历结束更新简历
    PROFILE_UPDATE: "PROFILE_UPDATE"
}

/**
 * 待办完成信号的事件接口
 */
export interface NoticeTodoCompleteEvent {
    entityId?: number,
    entitySheet?: string,
    userId?: number,
    action?: string,
    projectId?: number,
}


export interface WbsPanelEvent {
    isTask?: boolean,
}